import { lazy } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from './store';
import Layout from './components/Layout';
import AppModeInitializer from './AppModeInitializer';
import Routes from './routes/Routes';
const SessionTimer = lazy(() => import('./components/SessionTimer'));
const ModalRoot = lazy(() => import('./components/Commons/Modal/ModalRoot'));
const CommunicationsProvider = lazy(() => import('./components/Communications/Provider'));
const SurveyProvider = lazy(() => import('./components/Surveys/Provider'));

import 'bootstrap/dist/css/bootstrap.min.css';

const App = () => {
  return (
    <Provider store={store}>
      <Router basename={'/prestadores'}>
        <CommunicationsProvider />
        <SurveyProvider />
        <AppModeInitializer>
          <Layout>
            <Routes />
            <ModalRoot />
            <SessionTimer />
          </Layout>
        </AppModeInitializer>
      </Router>
    </Provider>
  );
};

export default App;
